import { UserDto } from "../../../types/dto";
import { getBlast, isMockMode, simulateDelay } from "../../api";

export const getUsersForOrg = ({ orgId }: { orgId: string }) => {
	if (isMockMode()) {
		const testData = {
			results: [
				{
					id: "3fa85f64-5717-4562-b5gh-2c963f66afa6",
					email: "test.mctestie@mgaol.abc",
					firstName: "Test",
					lastName: "McTestie",
				},
			],
		};

		return simulateDelay(50, () => testData) as Promise<{
			results: Array<UserDto>;
		}>;
	}

	return getBlast(`orgusers/getusersfororg?orgId=${orgId}`) as Promise<{
		results: Array<UserDto>;
	}>;
};
